import { isNil } from './index';

const calcWeight = (configuration) => {
    let weight = 0;
    weight += !isNil(configuration.model) ? configuration.model.weightRunningCondition : 0;
    Object.keys(configuration.configurations).forEach(key => {
        if (!isNil(configuration.configurations[key])) {
            if (Array.isArray(configuration.configurations[key])) {
                configuration.configurations[key].forEach(item => {
                    weight += item.weight;
                });
            } else {
                weight += configuration.configurations[key].weight;
            }
        }
    });
    return weight;
};

export default calcWeight;
